<template>
  <v-card
    v-resize="onResize"
    :loading="$store.getters.isLoading"
    :elevation="hover ? 16 : 2"
    :class="{ 'on-hover': hover }"
    rounded="xl"
    :height="height"
    class="d-flex flex-column"
  >
    <template slot="progress">
      <v-progress-linear height="5" indeterminate style="z-index: 10" />
    </template>
    <v-card-title id="header" style="z-index: 2" class="title-card test_red">
      <slot name="header" />
    </v-card-title>

    <v-card-text
      id="body"
      :class="[
        showActions ? 'body-height-actions' : 'body-height',
        isEmpty ? 'body-empty' : '',
      ]"
      class="overflow-y-auto test_yellow flex-md-grow-1 fill-height"
    >
      <slot name="body" />

      <CardEmptyList v-if="isEmpty" :title="emptyText" />
    </v-card-text>
    <div v-if="showActions" class="px-7">
      <v-divider></v-divider>
    </div>
    <v-card-actions v-if="showActions" id="actions" class="test_green">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "CardOrders",
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    windowSize: {
      x: 0,
      y: 0,
    },
    height: "100%",
    errorStatus: false,
  }),
  watch: {
    errorStatus: function () {
      if (this.errorStatus) {
        this.onResize();
      }
    },
  },
  mounted() {
    const self = this;

    // Safety check: ensure Echo is available before using it
    if (this.$echo && this.$echo.connector && this.$echo.connector.pusher) {
      this.$echo.connector.pusher.connection.bind("state_change", (states) => {
        if (states.current == "unavailable") {
          self.errorStatus = true;
        } else {
          self.errorStatus = false;
        }
      });
    } else {
      console.warn(
        "⚠️ Echo not available in CardOrders component. Pusher connection monitoring disabled."
      );
    }

    this.onResize();
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      let remove = 0;
      var error = $("#error-pusher-content").outerHeight(true);
      var bar = $("#bar-menu-admin").outerHeight(true);
      if (this.$vuetify.breakpoint.mobile) {
        remove = error + bar + 10;
      } else {
        var tab = $("#tab-menus").outerHeight(true) - 20;

        remove = error + tab + bar;
      }

      let total = window.innerHeight - remove;
      this.height = total + "px";
    },
  },
};
</script>
<style lang="scss">
.title-card {
  font-size: 1.2rem !important;
  background-color: rgba($color: #aaa, $alpha: 0.5);
}
#header {
  height: 70px;
}
#actions {
  height: 80px;
  padding: 0;
}
</style>
